import React from "react";

const BRAND_RED = "#E31E24";
const BRAND_NAVY = "#2B2B6B";

const MARIA_PHOTO = "/images/maria-climaco.jpg";
const GABRIELA_PHOTO = "/images/gabriela-gonzalez.jpg";

const stats = [
  { number: "10", label: "Alumni stories collected" },
  { number: "2019–24", label: "Graduating classes represented" },
  { number: "2", label: "Main programs: Business Admin. and Liberal Arts" },
  { number: "4", label: "First-person testimonials shared" },
];

const timeline = [
  {
    year: "2024",
    people: [
      {
        name: "Juan Sebastian Bonilla Guandique",
        program: "Transferred — Business Administration",
        track: "business",
        now: "Studying at Panamerican University ONLINE — Miami",
        quote:
          "It was a beautiful experience. I met a lot of people who still hold a place in my heart. American College prepared me for my entry into the working world, building skills I didn't have before.",
        email: "jsbonilla42@gmail.com",
        photo: null,
      },
      {
        name: "Alix Daniela Aquino Rivas",
        program: "Graduate — Liberal Arts",
        track: "arts",
        now: "Senior at Tech University — works as an English coach",
        quote: "A great place! Very good education and very good teachers.",
        email: "alixdaniela8@gmail.com",
        photo: null,
      },
      {
        name: "Gabriela Maria Azucena Gonzalez",
        program: "Graduate — Business Administration",
        track: "business",
        now: null,
        quote: null,
        email: "gabyazucena00@gmail.com",
        phone: "7862 1575",
        photo: GABRIELA_PHOTO,
      },
    ],
  },
  {
    year: "2023",
    people: [
      {
        name: "Valeria Nicole Flores Lemus",
        program: "Master’s — Gannon University",
        track: "business",
        now: null,
        quote:
          "A very enriching experience, both personally and academically. The professors I had the pleasure of learning from genuinely cared about my academic growth and were always willing to help.",
        email: "vfloreslemus900@gmail.com",
        photo: null,
      },
      {
        name: "Eduardo Alexander Martinez Rojas",
        program: "Graduate — Liberal Arts",
        track: "arts",
        now: null,
        quote: null,
        email: "eduardomrojass@gmail.com",
        photo: null,
      },
      {
        name: "Laura Fabiola Ortiz Rivera",
        program: "Graduate — Liberal Arts",
        track: "arts",
        now: null,
        quote: null,
        email: "fabiolaortiz.0804@gmail.com",
        photo: null,
      },
      {
        name: "Adriana Denise Menjivar Palacios",
        program: "Graduate — Liberal Arts",
        track: "arts",
        now: null,
        quote: null,
        email: "adridDenise11@gmail.com",
        photo: null,
      },
    ],
  },
  {
    year: "2022",
    people: [
      {
        name: "Rodrigo Fernando Rosales Azanudo",
        program: "Graduate — Liberal Arts",
        track: "arts",
        now: null,
        quote: null,
        email: "rosalesrodrigo2002@gmail.com",
        phone: "7815 2887",
        photo: null,
      },
      {
        name: "Roberto Andres Vassiliu Plam",
        program: "Graduate — Business Administration",
        track: "business",
        now: null,
        quote: null,
        email: "andres.vassiliu@gmail.com",
        photo: null,
      },
    ],
  },
  {
    year: "2019",
    people: [
      {
        name: "María Climaco",
        program: "Graduate — Business Administration",
        track: "business",
        now: "Works at BMO Bank and is pursuing a graduate degree — lives in Chicago, USA. Completed her studies at Loyola University Chicago, in-person.",
        quote:
          "My experience at American College was very positive and marked an important stage in my academic development. Starting my studies there helped me prepare for the next step: transferring to a university in the United States, which let me further expand my academic and professional opportunities.",
        email: "mariaclimaco.americano@gmail.com",
        phone: "+1 (708) 940-1254",
        photo: MARIA_PHOTO,
      },
    ],
  },
];

function initials(name) {
  return name
    .split(" ")
    .filter((w) => w.length > 2 || /^[A-Z\u00c0-\u00dc]/.test(w))
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}

function AlumniCard({ person }) {
  const isBusiness = person.track === "business";
  const accent = isBusiness ? BRAND_NAVY : BRAND_RED;

  return (
    <div
      style={{
        background: "#ffffff",
        border: "0.5px solid #e4e4e4",
        borderRadius: 4,
        padding: "1.4rem 1.5rem",
        display: "flex",
        flexDirection: "column",
        gap: 12,
        borderLeft: `3px solid ${accent}`,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        {person.photo ? (
          <img
            src={person.photo}
            alt={person.name}
            style={{
              width: 52,
              height: 52,
              borderRadius: "50%",
              objectFit: "cover",
              flexShrink: 0,
            }}
          />
        ) : (
          <div
            style={{
              width: 52,
              height: 52,
              borderRadius: "50%",
              background: accent,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 15,
              fontWeight: 500,
              color: "#ffffff",
              flexShrink: 0,
            }}
          >
            {initials(person.name)}
          </div>
        )}
        <div>
          <p style={{ fontSize: 15, fontWeight: 500, color: "#1a1a1a", margin: 0, lineHeight: 1.3 }}>
            {person.name}
          </p>
          <p style={{ fontSize: 12.5, color: accent, margin: "2px 0 0", fontWeight: 500 }}>
            {person.program}
          </p>
        </div>
      </div>

      {person.now && (
        <p style={{ fontSize: 13, color: "#5c5c5c", lineHeight: 1.55, margin: 0 }}>
          {person.now}
        </p>
      )}

      {person.quote && (
        <p
          style={{
            fontSize: 13,
            color: "#6b6b6b",
            lineHeight: 1.6,
            margin: 0,
            paddingLeft: 12,
            borderLeft: "2px solid #ececec",
            fontStyle: "italic",
          }}
        >
          “{person.quote}”
        </p>
      )}

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "4px 14px",
          marginTop: "auto",
          paddingTop: 10,
          borderTop: "0.5px solid #ececec",
        }}
      >
        <span style={{ fontSize: 12, color: "#9a9a9a" }}>{person.email}</span>
        {person.phone && <span style={{ fontSize: 12, color: "#9a9a9a" }}>{person.phone}</span>}
      </div>
    </div>
  );
}

function YearGroup({ year, people }) {
  return (
    <div style={{ display: "flex", gap: 28, marginBottom: "2.75rem" }}>
      <div className="alumni-year-rail" style={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0, width: 64 }}>
        <div
          style={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            background: BRAND_RED,
            flexShrink: 0,
          }}
        />
        <div style={{ width: 1, flex: 1, background: "#e4e4e4", marginTop: 8 }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <p
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 26,
            fontWeight: 700,
            color: BRAND_NAVY,
            margin: "-6px 0 1.1rem",
          }}
        >
          {year}
        </p>
        <div className="alumni-year-grid">
          {people.map((p) => (
            <AlumniCard key={p.name} person={p} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default function AlumniSection() {
  return (
    <section
      style={{
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
        padding: "4rem 2rem 3rem",
        maxWidth: 1100,
        margin: "0 auto",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@400;500&display=swap');

        .alumni-stats-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 12px;
          margin-bottom: 3rem;
        }

        .alumni-year-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 14px;
        }

        @media (max-width: 900px) {
          .alumni-stats-row { grid-template-columns: repeat(2, 1fr); }
        }

        @media (max-width: 640px) {
          .alumni-year-grid { grid-template-columns: 1fr; }
          .alumni-year-rail { width: 32px !important; }
        }
      `}</style>

      <div style={{ marginBottom: "3rem" }}>
        <span
          style={{
            display: "block",
            fontSize: 12,
            fontWeight: 500,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: BRAND_RED,
            marginBottom: 8,
          }}
        >
          Our alumni
        </span>
        <h2
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 36,
            fontWeight: 700,
            color: BRAND_NAVY,
            margin: "0 0 12px",
            lineHeight: 1.15,
          }}
        >
          Stories that started here,
          <br />
          and keep being written.
        </h2>
        <p style={{ fontSize: 15, color: "#6b6b6b", maxWidth: 520, lineHeight: 1.6, margin: 0 }}>
          From Business Administration to Liberal Arts, from Miami to Chicago:
          here's what our alumni have to say about what American College
          meant on their path.
        </p>
      </div>

      <div className="alumni-stats-row">
        {stats.map((s) => (
          <div
            key={s.label}
            style={{
              background: BRAND_NAVY,
              borderRadius: 12,
              padding: "1.25rem 1rem",
              display: "flex",
              flexDirection: "column",
              gap: 4,
            }}
          >
            <span
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: 26,
                fontWeight: 700,
                color: "#ffffff",
                lineHeight: 1,
              }}
            >
              {s.number}
            </span>
            <span style={{ fontSize: 12, color: "rgba(255,255,255,0.65)", fontWeight: 400, lineHeight: 1.4 }}>
              {s.label}
            </span>
          </div>
        ))}
      </div>

      <div>
        {timeline.map((group) => (
          <YearGroup key={group.year} year={group.year} people={group.people} />
        ))}
      </div>

      <div
        style={{
          marginTop: "1rem",
          border: "0.5px solid #e4e4e4",
          borderRadius: 12,
          padding: "1.25rem 1.5rem",
          display: "flex",
          alignItems: "center",
          gap: 14,
        }}
      >
        <div style={{ width: 8, height: 8, borderRadius: "50%", background: BRAND_RED, flexShrink: 0 }} />
        <p style={{ fontSize: 14, color: "#6b6b6b", lineHeight: 1.5, margin: 0 }}>
          Are you an alumni and want to share your story? Add it to this
          timeline by reaching out to the alumni office.
        </p>
      </div>
    </section>
  );
}